<ac-card class="level-up-reward-dialog" [style.--tier-color]="color">
  <ac-card-header [hideBack]="true" (close)="close()" />

  <ac-card-content>

    <div class="level-up-body ac-flex-col ac-ctr ac-gap-xl ac-width-full">
      <div class="ac-headline-sm ac-text-ctr">{{ title }} Level Up</div>

      <div class="tier-badge ac-flex ac-ctr">
        @if (badgeUrl; as logo) {
          <img [src]="logo" [alt]="title" class="tier-logo" />
        } @else {
          <ac-icon iconKey="hr:vip_level" [size]="120" />
        }
      </div>

      <div class="ac-flex-col ac-ctr ac-gap-md ac-width-full">
        <div class="ac-headline-sm">You just earned</div>
        <div class="earned-row ac-flex ac-ctr ac-algn-ctr ac-gap-sm ac-title-lg">
          <span class="ac-flex ac-algn-ctr ac-gap-sm">
            <app-gc-icon type="3d" [size]="20" />
            {{ claim.reward_gc | number }}
          </span>
          <span class="plus">+</span>
          <span class="ac-flex ac-algn-ctr ac-gap-sm">
            <app-sc-icon type="3d" [size]="20" />
            {{ claim.reward_sc | number: '0.0-2' }}
          </span>
        </div>
      </div>
    </div>
  </ac-card-content>

  <ac-card-actions>
    <button
      mat-flat-button
      type="button"
      class="claim-button ac-width-full ac-btn-lg"
      [disabled]="timeout()"
      [loading]="claiming()"
      [disabledInteractive]="true"
      [matTooltip]="timeout()"
      [matTooltipDisabled]="!timeout()"
      (click)="claimReward()"
    >
      Claim Reward
    </button>
  </ac-card-actions>
</ac-card>
